export default "__VITE_ASSET__BGkH9UkG__"